module.exports = __webpack_public_path__ + "static/media/matche.2f043298.svg";